import {
  Input,
  Button,
  FormItem,
  Form,
  Select,
  Switch,
  MessageBox,
  Message,
  Carousel,
  CarouselItem,
  Pagination,
  Table,
  TableColumn,
  Radio,
  Upload,
  Option,
  Steps,
  Step,
  divider,
  Card,
  Container,
  Aside,
  Main,
  Menu,
  MenuItem,
  Tabs,
  TabPane,
  Breadcrumb,
  BreadcrumbItem,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
} from "element-ui";
const element = {
  install: function (Vue) {
    Vue.use(Dialog);
    Vue.use(Button);
    Vue.use(Switch);
    Vue.use(Select);
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(Input);
    Vue.use(Carousel);
    Vue.use(CarouselItem);
    Vue.use(Pagination);
    Vue.use(Table);
    Vue.use(TableColumn);
    Vue.use(Upload);
    Vue.use(Radio);
    Vue.use(Option);
    Vue.use(Steps);
    Vue.use(Step);
    Vue.use(divider);
    Vue.use(Card);
    Vue.use(Container);
    Vue.use(Aside);
    Vue.use(Main);
    Vue.use(Menu);
    Vue.use(MenuItem);
    Vue.use(Tabs);
    Vue.use(TabPane);
    Vue.use(Breadcrumb);
    Vue.use(Dropdown);
    Vue.use(DropdownMenu);
    Vue.use(DropdownItem);
    Vue.use(BreadcrumbItem);
    Vue.prototype.$msgbox = MessageBox;
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$prompt = MessageBox.prompt;
    Vue.prototype.$notify = Notification;
    Vue.prototype.$message = Message;
  },
};
export default element;
